<div class="wrapper">
    <!-- <app-top-slider [isMinimal]="true"></app-top-slider> -->
    <app-search-image-rotator [pageBgList]="data"></app-search-image-rotator>

    <div class="FormatFilter" [ngClass]="{open: searchService.isFormatFilterOpen}">
        <div class="close" (click)="closeFormatFilter()">
            <mat-icon>close</mat-icon>
        </div>
        <div class="genreList formatList">
            <div class="genreItem" *ngFor="let item of searchService.formatList; let i=index"
                [ngClass]="{active: item.active}" (click)="formatItemClick(item, i)">
                <div class="bullet">•</div>
                <div class="label">{{item.title}}</div>
            </div>
        </div>
    </div>

    <div class="genreFilter" [ngClass]="{open: searchService.isGenreFilterOpen}">
        <div class="close" (click)="closeGenreFilter()">
            <mat-icon>close</mat-icon>
        </div>
        <div class="genreList">
            <div class="genreItem" *ngFor="let item of searchService.genreList; let i=index"
                [ngClass]="{active: item.active}" (click)="genreItemClick(item, i)">
                <div class="bullet">•</div>
                <div class="label">{{item.title}}</div>
            </div>
        </div>
    </div>


    <div class="RatingFilter" [ngClass]="{open: searchService.isRatingFilterOpen}">
        <div class="close" (click)="closeRatingFilter()">
            <mat-icon>close</mat-icon>
        </div>
        <div class="genreList">
            <div class="genreItem" *ngFor="let item of searchService.ratingList; let i=index"
                [ngClass]="{active: item.active}" (click)="ratingItemClick(item, i)">
                <div class="bullet">•</div>
                <div class="label">{{item.title}}</div>
            </div>
        </div>
    </div>

    <div class="content">

        <div class="searchWrapper">
            <app-search-input (changeEvent)="searchText($event)" (searchEvent)="searchText($event)" color="white"></app-search-input>
        </div>

        <!-- <input (input)="search($event)" [value]="query" /> -->

        <!-- <ul>
            <li *ngFor="let hit of hits">{{ hit['objectID'] }} {{ hit['Title'] }}</li>
        </ul> -->



        <div class="resultsWrapper" *ngIf="isShowResults">
            <div class="ttl" *ngIf="franchises.length > 0">
                <div class="title">
                    <mat-icon matSuffix>south</mat-icon>
                    <div class="label">
                        Franchise Search results for: {{searchInput}}
                        <span *ngIf="searchService.activeGenreList.length"> | Genre&nbsp;<span
                                [innerHTML]="searchService.activeGenreListStr"></span></span>

                        <span *ngIf="searchService.activeRatingList.length"> | Rated&nbsp;<span
                                [innerHTML]="searchService.activeRatingListStr"></span></span>

                        <span *ngIf="searchService.activeformatList.length>0"> | Format&nbsp;<span
                                [innerHTML]="searchService.activeformatListStr"></span></span>

                    </div>
                </div>
                <div class="closeHolder" (click)="closeResults()">
                    <div class="label">CLEAR RESULTS</div>
                    <mat-icon matSuffix>close</mat-icon>
                </div>

            </div>

            <div class="resultsHolder" *ngIf="franchises.length > 0">

                <app-poster-card [movie]="movie" *ngFor="let movie of franchises | orderByDate:skipSort"></app-poster-card>

                <!-- <div class="noResults" *ngIf="movies.length == 0">
                    No Results found.
                </div> -->

            </div>

            <div class="ttl" *ngIf="movies.length > 0">
                <div class="title">
                    <mat-icon matSuffix>south</mat-icon>
                    <div class="label">
                        Movie Search results for: {{searchInput}}
                        <span *ngIf="searchService.activeGenreList.length"> | Genre&nbsp;<span
                                [innerHTML]="searchService.activeGenreListStr"></span></span>

                        <span *ngIf="searchService.activeRatingList.length"> | Rated&nbsp;<span
                                [innerHTML]="searchService.activeRatingListStr"></span></span>

                        <span *ngIf="searchService.activeformatList.length>0"> | Format&nbsp;<span
                                [innerHTML]="searchService.activeformatListStr"></span></span>



                    </div>
                </div>
                <div class="closeHolder" (click)="closeResults()">
                    <div class="label">CLEAR RESULTS</div>
                    <mat-icon matSuffix>close</mat-icon>
                </div>

            </div>

            <div class="resultsHolder" *ngIf="movies.length > 0">

                <app-poster-card [movie]="movie" *ngFor="let movie of movies | orderByDate:skipSort"></app-poster-card>

                <!-- <div class="noResults" *ngIf="movies.length == 0">
                    No Results found.
                </div> -->

            </div>

            <div class="ttl" *ngIf="cast.length > 0">
                <div class="title">
                    <mat-icon matSuffix>south</mat-icon>
                    <div class="label">
                        Cast Search results for: {{searchInput}}
                    </div>
                </div>
                <div class="closeHolder" (click)="closeResults()" *ngIf="movies.length == 0">
                    <div class="label">CLEAR RESULTS</div>
                    <mat-icon matSuffix>close</mat-icon>
                </div>

            </div>

            <div class="resultsHolder" *ngIf="cast.length > 0">
                <div class="posterWrapper" *ngFor="let castItem of cast | orderSearchByDate">
                    <div class="castName">
                        Cast:
                        <span [innerHTML]="castItem.searchText | safeHtml"></span>
                    </div>

                    <app-poster-card [movie]="castItem.movie"></app-poster-card>
                </div>

                <!-- <div class="noResults" *ngIf="cast.length == 0">
                    No Results found.
                </div> -->

            </div>


            <div class="ttl" *ngIf="directors.length > 0">
                <div class="title">
                    <mat-icon matSuffix>south</mat-icon>
                    <div class="label">
                        Director Search results for: {{searchInput}}
                    </div>
                </div>
                <div class="closeHolder" (click)="closeResults()" *ngIf="movies.length == 0 && cast.length == 0">
                    <div class="label">CLEAR RESULTS</div>
                    <mat-icon matSuffix>close</mat-icon>
                </div>

            </div>

            <div class="resultsHolder" *ngIf="directors.length > 0">
                <div class="posterWrapper" *ngFor="let directorItem of directors | orderSearchByDate">
                    <div class="castName">
                        Director:
                        <span [innerHTML]="directorItem.searchText | safeHtml"></span>
                    </div>
                    <app-poster-card [movie]="directorItem.movie"></app-poster-card>
                </div>


            </div>
            <div class="paginatorHolder" *ngIf="length > 1">

                <mat-paginator 
                    [length]="length" 
                    (page)="handlePageEvent($event)"
                    [pageSizeOptions]="[1]"
                    [hidePageSize]="hidePageSize"
                    [pageIndex]="pageIndex"
                    ></mat-paginator>
            </div>
            <!-- <mat-paginator #paginator
               class="demo-paginator"
               (page)="handlePageEvent($event)"
               [length]="length"
               [pageSize]="pageSize"
               [disabled]="disabled"
               [showFirstLastButtons]="showFirstLastButtons"
               [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
               [hidePageSize]="hidePageSize"
               [pageIndex]="pageIndex"
               aria-label="Select page">
</mat-paginator> -->

            <!-- No Results found -->

            <div class="ttl" *ngIf="directors.length == 0 && movies.length == 0 && cast.length == 0 && franchises.length == 0 && showError">
                <div class="title">
                    <mat-icon matSuffix>south</mat-icon>
                    <div class="label">
                        No Results found for: {{searchInput}} <span *ngIf="searchService.activeGenreList.length">
                            Genre <span [innerHTML]="searchService.activeGenreListStr"></span></span>

                        <span *ngIf="searchService.activeRatingList.length"> | Rated&nbsp;<span
                                [innerHTML]="searchService.activeRatingListStr"></span></span>

                        <span *ngIf="searchService.activeformatList.length>0"> | Format&nbsp;<span
                                [innerHTML]="searchService.activeformatListStr"></span></span>
                    </div>
                </div>
                <div class="closeHolder" (click)="closeResults()" *ngIf="movies.length == 0">
                    <div class="label">CLEAR RESULTS</div>
                    <mat-icon matSuffix>close</mat-icon>
                </div>

            </div>


        </div>

        <div class="noResults"
            *ngIf="directors.length == 0 && movies.length == 0 && cast.length == 0 && isShowResults && !showError">
            Searching
        </div>


        <div class="initialPage" *ngIf="!isShowResults">
            <div class="listWrapper">
                <app-square-list [isGenre]="true" [title]="'Browse By Genres'"
                    [SquarePromo]="pageService.searchPage.genreList" [numberOnScreen]="6"></app-square-list>
            </div>

            <div class="listWrapper">
                <app-square-list [title]="'Franchises'" [SquarePromo]="pageService.homePage.franciseList"
                    [numberOnScreen]="5"></app-square-list>
            </div>


            <div class="listWrapper">
                <app-poster-list [title]="'Classics'" [movies]="pageService.homePage.classicsList"></app-poster-list>
            </div>

            <div class="legal">Films and available formats are subject to final sales team approval.</div>
        </div>

    </div>
</div>